import { useContext } from "react";
import { Link } from "react-router-dom";
import Icon from "../components/icon";
import LanguageContext from "../context/language";
import useTealiumOnPageLoad from "../utils/tealium";
import ContactUsFooter from "../components/contact-us-footer";
import Faqs from "../components/faqs";
import staticFaqs from "../utils/static-faqs";
import classNames from "classnames";
import useRedirectMicrosoft from "../hooks/queries/useRedirectMicrosoft";

const ForgotPassword = () => {
  const { labels, browserLanguage } = useContext(LanguageContext);
  const { data: redirectUrl } = useRedirectMicrosoft();

  useTealiumOnPageLoad({ notLogged: true });

  return (
    <main
      className={classNames(
        "page forgot-password wrapper-small",
        !browserLanguage && "loading-skeleton"
      )}
    >
      <div className="forgot-password__back">
        <Link to="/login" aria-label={labels?.BACK_TO_LOGIN}>
          <Icon name="arrow" /> {labels?.BACK_TO_LOGIN}
        </Link>
      </div>
      <div className="forgot-password__box">
        <h1 className="forgot-password__title title" data-label="CONTACT_AND_SUPPORT">
          {labels?.CONTACT_AND_SUPPORT || "Contact and support"}
        </h1>
        <div
          data-label="FORGOT_PASSWORD_TEXT_DESCRIPTION"
          dangerouslySetInnerHTML={{
            __html:
              labels?.FORGOT_PASSWORD_TEXT_DESCRIPTION ||
              "Use your corporate credentials to login into EssilorLuxottica Intranet.</br>We are working to provide all users with a Microsoft Office 365 account.",
          }}
        />
        <div className="forgot-password__cards-wrapper">
          <div className="forgot-password__cards">
            <div className="forgot-password__card">
              <div className="forgot-password__card-header">
                <div
                  className="forgot-password__card-name"
                  data-label="FORMER_LUXOTTICA"
                  dangerouslySetInnerHTML={{
                    __html: labels?.CORPORATE_CREDENTIALS,
                  }}
                />
                <div
                  data-label="FORMER_LUXOTTICA_DESCRIPTION"
                  className="forgot-password__card-description"
                  dangerouslySetInnerHTML={{
                    __html: labels?.FORMER_LUXOTTICA_DESCRIPTION,
                  }}
                />
              </div>
              <a
                href="https://account.luxottica.com/password/?returnURL=https%3A%2F%2Flogon.luxottica.com%2Fnidp%2Fapp%2Flogin"
                target="_blank"
                className="forgot-password__label cta-link"
                data-label="FORGOT_PASSWORD"
              >
                {labels?.FORGOT_YOUR_PASSWORD || "FORGOT YOUR PASSWORD?"}
              </a>
            </div>
            <div className="forgot-password__card ">
              <div className="forgot-password__card-header">
                <div
                  className="forgot-password__card-name"
                  data-label="FORMER_MICROSOFT365"
                  dangerouslySetInnerHTML={{
                    __html: labels?.FORMER_MICROSOFT365 || "MICROSOFT 365",
                  }}
                />
                <div
                  data-label="LOGIN_WITH_MICROSOFT_365_DESCRIPTION"
                  className="forgot-password__card-description"
                  dangerouslySetInnerHTML={{
                    __html:
                      labels?.LOGIN_WITH_MICROSOFT_365_DESCRIPTION ||
                      "To login, please enter  your microsoft 365 credentials. Lorem ipsum dolor sit amet undo omini domni anomisetpur leretis del maret.",
                  }}
                />
              </div>
              <a
                href={redirectUrl}
                target="_blank"
                className="forgot-password__label cta-link"
                data-label="FORGOT_PASSWORD"
              >
                {labels?.FORGOT_YOUR_PASSWORD || "FORGOT YOUR PASSWORD?"}
              </a>
            </div>
          </div>
        </div>
        <h1 className="forgot-password__title title" data-label="CONTACT_AND_SUPPORT">
          {labels?.FREQUENTLY_ASKED_QUESTIONS || "Frequently asked questions"}
        </h1>
      </div>
      <Faqs faqs={staticFaqs(browserLanguage)} />
      <ContactUsFooter />
    </main>
  );
};

export default ForgotPassword;
